import { HYDRATE } from 'next-redux-wrapper';

import { ERROR_TAGS, GET_TAGS, SET_TAGS } from '../actionTypes/tags';

const initialState = {
    fetching: false,
    fetchError: null,
    items: [],
};

export default function reducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case HYDRATE:
            return { ...state, ...action.payload.tags };
        case GET_TAGS:
            return { ...state, ...payload };
        case SET_TAGS:
            return { ...state, ...payload };
        case ERROR_TAGS:
            return { ...state, ...payload };
        default:
            return state;
    }
}
